import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-deactivate-team-dialog',
  templateUrl: './deactivate-team-dialog.component.html',
  styleUrls: ['./deactivate-team-dialog.component.scss'],
})
export class DeactivateTeamDialogComponent {
  private readonly dialogRef = inject(DialogRef<boolean>);

  public confirm(): void {
    this.dialogRef.close(true);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
